// Libraries
import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

// APIS
import ApiCatalogCMS from '../../../api/Catalog/CategoryCMS';
import ApiProducts from '../../../api/Product';
import ApiMenuShop from '../../../api/Menus/shop';
import ApiMenuJoin from '../../../api/Menus/join';
import ApiMenuAbout from '../../../api/Menus/about';

import LinkWrap from '../../Wraps/LinkWrap';
import LinkLang from '../../Wraps/LinkLang';

import Config, { spanish } from '../../../config/config';

const Products = ({ category }) => {
  const featuredItems = category?.filter((item) => item?.isFeatured === true);
  const items = (featuredItems || [])?.map((product, key) => (
    <LinkLang
      to={`/product/${product?.SLUG}`}
      key={key}
      state={{ sku: product?.SKU }}
    >
      {product?.imageCatalog?.formats?.thumbnail?.url && (
        <img
          src={
            Config.cdn.cdn_path + product?.imageCatalog?.formats?.thumbnail?.url
          }
          alt={product?.Name}
        />
      )}
      <p>{product?.Name}</p>
    </LinkLang>
  ));
  return <div className={styles.submenuProducts}>{items}</div>;
};

const SubmenuStore = ({ onBlur, categoriesInfo }) => {
  const [content, setContent] = useState(null);
  const topCategory = categoriesInfo?.find((cat) => cat?.Position === 1);
  const topCategoryItems = topCategory?.products.filter(
    (item) => item?.isFeatured
  );
  const [selectedCategory, setSelectedCategory] = useState(topCategoryItems);
  useEffect(async () => {
    setContent(await ApiMenuShop.getContent());
  }, []);

  const orderedList = categoriesInfo?.sort((a, b) => a?.Position - b?.Position);

  const categories = orderedList?.map((item) => (
    <Link
      to={{
        pathname: `${spanish ? '/mex/es-mx' : '/mex/en-us'}/category/${
          item?.SLUG
        }`,
        state: {
          categoryId: item?.categoryID,
          categoryName: spanish ? item?.NameSpanish : item?.NameEnglish,
        },
      }}
      key={item?.id}
      onMouseEnter={() =>
        setSelectedCategory(
          item?.products.filter((el) => el.SKU !== '801' && el.SKU !== '902')
        )
      }
    >
      {spanish ? item?.NameSpanish : item?.NameEnglish}
    </Link>
  ));

  return (
    <div className={styles.submenu} onBlur={onBlur} onMouseLeave={onBlur}>
      <div className={styles.submenuContainer}>
        {content && (
          <div className={styles.submenuContent}>
            <div className={styles.submenuLeft}>
              <h4>
                {spanish
                  ? content?.ListTitleSpanish
                  : content?.ListTitleEnglish}
              </h4>
              {categoriesInfo && categories}
            </div>
            <div className={styles.submenuMiddle}>
              <h4>
                {spanish
                  ? content?.ProductsTitleSpanish
                  : content?.ProductsTitleEnglish}
              </h4>
              {categoriesInfo && selectedCategory && (
                <Products category={selectedCategory} />
              )}
            </div>
            <div className={styles.submenuRight}>
              <h4>
                {spanish
                  ? content?.BannerTitleSpanish
                  : content?.BannerTitleEnglish}
              </h4>
              <LinkWrap to={content?.LinkTo} isExternal={content?.External}>
                <img
                  src={Config.cdn.cdn_path + content?.Banner?.url}
                  alt={
                    spanish
                      ? content?.BannerTitleSpanish
                      : content?.BannerTitleEnglish
                  }
                />
              </LinkWrap>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const SubmenuJoin = ({ onBlur }) => {
  const [links, setLinks] = useState(null);
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setLinks(await ApiMenuJoin.getLinks());
    setContent(await ApiMenuJoin.getContent());
  }, []);
  return (
    <div className={styles.submenu} onBlur={onBlur} onMouseLeave={onBlur}>
      <div className={styles.submenuContainer}>
        {links && content && (
          <div className={styles.submenuContent}>
            <div className={styles.submenuLeft}>
              <h4>
                {spanish
                  ? content?.ListTitleSpanish
                  : content?.ListTitleEnglish}
              </h4>
              {links?.map((item, key) => (
                <LinkWrap
                  to={item?.LinkTo}
                  isExternal={item?.External}
                  key={key}
                >
                  {spanish ? item?.NameSpanish : item?.NameEnglish}
                </LinkWrap>
              ))}
            </div>
            <div className={styles.submenuMiddle}>
              <h4>
                {spanish
                  ? content?.BigBannerTitleSpanish
                  : content?.BigBannerTitleEnglish}
              </h4>
              <LinkWrap
                to={content?.BigBannerLinkTo}
                isExternal={content?.BigBannerExternal}
              >
                <img
                  src={Config.cdn.cdn_path + content?.BigBannerImage?.url}
                  alt={
                    spanish
                      ? content?.BigBannerTitleSpanish
                      : content?.BigBannerTitleEnglish
                  }
                />
              </LinkWrap>
            </div>
            <div className={styles.submenuRight}>
              <h4>
                {spanish
                  ? content?.SmallBannerTitleSpanish
                  : content?.SmallBannerTitleEnglish}
              </h4>
              <LinkWrap
                to={content?.SmallBannerLinkTo}
                isExternal={content?.SmallBannerExternal}
              >
                <img
                  src={Config.cdn.cdn_path + content?.SmallBannerImage?.url}
                  alt={
                    spanish
                      ? content?.SmallBannerTitleSpanish
                      : content?.SmallBannerTitleEnglish
                  }
                />
              </LinkWrap>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const AddressContent = ({ data }) => {
  const {
    Brand,
    Address,
    CustomerCareSpanish,
    CustomerCareEnglish,
    Phone,
    Email,
  } = data;
  return (
    <div className={styles.address}>
      <b>{Brand}</b>
      <p>{Address}</p>
      <b>{spanish ? CustomerCareSpanish : CustomerCareEnglish}</b>
      <p>{Phone}</p>
      <a href={`mailto:${Email}`}>{Email}</a>
    </div>
  );
};

const SubmenuAbout = ({ onBlur }) => {
  const [links, setLinks] = useState(null);
  const [content, setContent] = useState(null);
  const [address, setAddress] = useState(null);
  useEffect(async () => {
    setLinks(await ApiMenuAbout.getLinks());
    setContent(await ApiMenuAbout.getContent());
    setAddress(await ApiMenuAbout.getAddress());
  }, []);
  return (
    <div className={styles.submenu} onBlur={onBlur} onMouseLeave={onBlur}>
      <div className={styles.submenuContainer}>
        {links && content && address && (
          <div className={styles.submenuContent}>
            <div className={styles.submenuLeft}>
              <h4>
                {spanish
                  ? content?.ListTitleSpanish
                  : content?.ListTitleEnglish}
              </h4>
              {links?.map((item, key) => (
                <LinkWrap
                  to={item?.LinkTo}
                  isExternal={item?.External}
                  key={key}
                >
                  {spanish ? item?.NameSpanish : item?.NameEnglish}
                </LinkWrap>
              ))}
            </div>
            <div className={styles.submenuMiddle}>
              <h4>
                {spanish
                  ? content?.BannerTitleSpanish
                  : content?.BannerTitleEnglish}
              </h4>
              <LinkWrap to={content?.LinkTo} isExternal={content?.External}>
                <img
                  src={Config.cdn.cdn_path + content?.Banner?.url}
                  alt={
                    spanish
                      ? content?.BannerTitleSpanish
                      : content?.BannerTitleEnglish
                  }
                />
              </LinkWrap>
            </div>
            <div className={styles.submenuRight}>
              <h4>
                {spanish
                  ? content?.ContactTitleSpanish
                  : content?.ContactTitleEnglish}
              </h4>
              {address && <AddressContent data={address} />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// eslint-disable-next-line import/prefer-default-export
export const Navigation = () => {
  const [submenu, setSubmenu] = useState('');
  const [categories, setCategories] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const handleSubmenu = (section) => {
    if (section === '' || section !== submenu) {
      setSubmenu(section);
    } else {
      setSubmenu('');
    }
  };

  const getCategoriesInfo = useCallback(async () => {
    try {
      const resp = await ApiCatalogCMS.getCategories();
      if (resp && resp.length) {
        setCategories(resp);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getFeaturedProducts = useCallback(async () => {
    try {
      const resp = await ApiProducts.getFeatured();
      if (resp && resp.length) {
        setFeaturedProducts(resp);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getCategoriesInfo();
    getFeaturedProducts();
  }, [getCategoriesInfo]);

  return (
    <div className={styles.navigation}>
      <button type="button" onClick={() => handleSubmenu('store')}>
        {spanish ? 'Tienda' : 'Shop'}
      </button>
      <button type="button" onClick={() => handleSubmenu('join')}>
        {spanish ? 'Unirse' : 'Join'}
      </button>
      <button type="button" onClick={() => handleSubmenu('about')}>
        {spanish ? 'Acerca de' : 'About'}
      </button>
      <div className={styles.submenus}>
        {submenu === 'store' ? (
          <SubmenuStore
            onBlur={handleSubmenu}
            categoriesInfo={categories}
            featuredProductsInfo={featuredProducts}
          />
        ) : (
          ''
        )}
        {submenu === 'join' ? <SubmenuJoin onBlur={handleSubmenu} /> : ''}
        {submenu === 'about' ? <SubmenuAbout onBlur={handleSubmenu} /> : ''}
      </div>
    </div>
  );
};
